// frontend/src/pages/model/Switch.jsx
// An on/off switch in the graphite style (D9): a light track when on. A real
// button with role="switch", so it works with the keyboard (Space/Enter) and
// screen readers announce its state; `label` is its accessible name.
import React from 'react';
import { cn } from '@/lib/utils';

export default function Switch({ checked, onChange, label, disabled = false, title }) {
  return (
    <button
      type="button" role="switch" aria-checked={checked} aria-label={label} title={title} disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-white/30 disabled:cursor-not-allowed disabled:opacity-50',
        checked ? 'bg-[var(--ui-selected)]' : 'bg-[var(--ui-chip)]',
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          'inline-block h-3.5 w-3.5 rounded-full transition-transform',
          checked ? 'translate-x-[18px] bg-[var(--ui-selected-text)]' : 'translate-x-[3px] bg-[var(--ui-text-muted)]',
        )}
      />
    </button>
  );
}
